<template>
    <div>
        <v-card flat>
            <v-alert dense outlined type="error" v-if="alertError">
                No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
            </v-alert>            
            <v-toolbar title elevation="1">
                <v-toolbar-title class="tituloMaquinaria">Tipos de Herramientas</v-toolbar-title>
                <v-divider vertical class="ml-3"></v-divider>    

                <v-spacer></v-spacer>      
                <v-text-field outlined class=" pr-4"
                    label="Buscar Tipo Herramienta"
                    v-model="buscarTipoHerramienta"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                ></v-text-field>
                <v-tooltip bottom color="#0019d8" v-if="permisos.crear">
                    <template v-slot:activator="{ on }">
                        <v-btn color="#0019d8" @click="AbrirModalRegistrarTipoHerramienta()" dark rounded v-on="on">
                            <v-icon left>fas fa-save</v-icon> Crear
                        </v-btn>
                    </template>
                    <span>Nuevo Tipo Herramienta</span>
                </v-tooltip>                                      
            </v-toolbar>
            <v-data-table
                :headers="EncabezadoTablaTipoHerramienta"
                :items="ArrayTiposHerramientas"
                class="elevation-1"
                :search="buscarTipoHerramienta"
                :footer-props="{itemsPerPageText: 'Filas por página'}"                 
                :loading="loading"
                loading-text="Cargando Datos..."                                
            >
                <template v-slot:item.action="{ item }">
                    <v-tooltip left color="#d69b01">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#d69b01" v-on="on" @click="AbrirModalEditarTipoHerramienta(item)">
                                <v-icon small>fas fa-edit</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Editar Tipo Herramienta</span>
                    </v-tooltip>                                              
                    <v-tooltip left color="#D80000" v-if="permisos.eliminar">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#D80000" v-on="on" @click="AbrirModalEliminarTipoHerramienta(item)">
                                <v-icon small>fas fa-trash-alt</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Eliminar Tipo Herramienta</span>
                    </v-tooltip>                                              
                </template>            
                <template v-slot:no-results>
                    <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo">
                        Tipo de Herramienta no existe
                    </v-alert>                        
                </template>                
                <template v-slot:no-data v-if="ArrayTiposHerramientas.length === 0">
                    <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" v-if="!alertError">
                        No existen Tipos de Herramienta registrados
                    </v-alert>
                    <v-alert dense outlined type="error" v-if="alertError">
                        No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
                    </v-alert>
                </template>                                
            </v-data-table>
        </v-card>
        <!-- mostramos el circular progress cuando carguen los datos para editar un tipo de Herramienta -->
        <v-overlay :value="EstadoCircularProgress">
            <v-progress-circular indeterminate :size="80" :width="10" color="#ffffff"></v-progress-circular>
        </v-overlay>                      
        <RegistrarTipoHerramienta 
            :AbrirDialogoRegistrarTipoHerramienta="AbrirDialogoRegistrarTipoHerramienta" @CerrarModalRegistrarTipoHerramienta="CerrarModalRegistrarTipoHerramienta"
            :esNuevo="esNuevo" :TituloDialogo="TituloDialogo" @TodosTiposHerramientas="TodosTiposHerramientas"
            :DatosEditarTipoHerramienta="DatosEditarTipoHerramienta" :EstadoPermisoEditar="EstadoPermisoEditar"
        />
        <MensajeEliminar 
            :DialogoMensajeEliminar="DialogoMensajeEliminar" @CerrarDialogoMensajeEliminar="CerrarDialogoMensajeEliminar"
            :tituloMensajeEliminar="tituloMensajeEliminar" @Eliminar="EliminarTipoHerramienta"
            :loadingEliminarHerramientaMateriaPrima="loadingEliminarTipoHerramienta" :alertError="alertError"
        />        
    </div>    
</template>

<script>
import { mapGetters, mapActions  } from 'vuex'
import { showMessageError, showMessageSuccess } from '../../../../services/sweetAlert'
import RegistrarTipoHerramienta from '../../../../components/IngresoNuevaInformacion/Tipos/TipoHerramienta/RegistrarTipoHerramienta'
import MensajeEliminar from '../../../../components/MensajeEliminar'

export default {
    props: {
        tab: String
    },

    components: {
        RegistrarTipoHerramienta,
        MensajeEliminar,
    },
    data() {
        return {
            EncabezadoTablaTipoHerramienta:[
                {text: 'Tipo Herramienta', value: 'nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],                   
            buscarTipoHerramienta:'',
            ArrayTiposHerramientas:[],
            loading:false,
            alertError:false,
            //variables para los permisos del colaborador
            namespace:'oidcStore/',
            EstadoPermisoEditar: false,
            permisos:{
                crear:false,
                editar:false,
                eliminar:false
            },
            // nuevo tipo de Herramienta
            esNuevo: false,
            TituloDialogo:'',
            AbrirDialogoRegistrarTipoHerramienta: false,
            // eliminar tipo de Herramienta
            DialogoMensajeEliminar:false,
            tituloMensajeEliminar:'',
            loadingEliminarTipoHerramienta: false,
            IdTipoHerramienta: '',
            // editar tipo de Herramienta
            DatosEditarTipoHerramienta:{},
            EstadoCircularProgress:false,
        }
    },

    computed: {
        ...mapGetters('oidcStore', [
            'oidcIsAuthenticated',
            'oidcUser'
        ]),      
    },    

    watch: {
        tab(){
            if(this.tab==="tab-3")this.TodosTiposHerramientas()
        }
    },

    created() {
        this.TodosTiposHerramientas()
        this.ObtenerPermisosSubmenuUsuario()
    },

    methods: {
        // metodos para obtener los permisos del colaborador a este modulo
            ...mapActions('oidcStore', ['authenticateOidcSilent',
                    'signOutOidc', 'authenticateOidc']),
            async ObtenerPermisosSubmenuUsuario(role){
                if (this.$store.getters[this.namespace + 'oidcIsAuthenticated']) {
                    if(this.$store.getters['oidcStore/oidcUser'].role === 'Administrador'){
                            this.permisos.crear = true
                            this.permisos.editar = true
                            this.permisos.eliminar = true
                            return 0            
                    }else{
                        //preguntar al backend por los permisos del submenu del usuario
                            var url = 'tipo'
                            const response  = await this.$store.dispatch('PermisosSubMenu', url)
                            if(typeof response === 'undefined'){
                                this.alertError=true
                                this.loading=false
                                return 0
                            }                                                 
                            if(response.status === 200){
                                this.alertError= false
                                this.permisos = response.data         
                            }else if(response.status === 400){
                                showMessageError('Error 400','Petición mala')
                            }else if(response.status === 404){
                                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                            }else if(response.status === 500){
                                showMessageError('Error 500','Error en el servidor')            
                            }
                            return 0
                    }
                }
            },                    
        // controlamos las excepciones de las peticiones al api
            ControllerException(response){
                if(typeof response === 'undefined'){
                    this.alertError=true
                    this.loading = false
                    this.EstadoCircularProgress = false
                    this.loadingEliminarTipoHerramienta = false
                    return 0
                }if(response.status === 200){
                    this.alertError= false
                    this.loading = false                    
                    if(this.TituloDialogo === "eliminar"){
                        showMessageSuccess('¡BIEN!', 'Tipo Herramienta eliminado correctamente')
                        this.TituloDialogo = ''
                        this.TodosTiposHerramientas()
                        this.loadingEliminarTipoHerramienta = false
                        this.CerrarDialogoMensajeEliminar()
                    }else if(this.TituloDialogo === "Editar"){
                        if(this.permisos.editar) this.EstadoPermisoEditar = this.permisos.editar
                        else this.EstadoPermisoEditar = this.permisos.editar
                        this.DatosEditarTipoHerramienta = response.data
                        this.EstadoCircularProgress = false
                        this.AbrirDialogoRegistrarTipoHerramienta = true
                    }else{
                        this.ArrayTiposHerramientas = response.data
                    }
                }else if(response.status === 400){
                    showMessageError('Error 400','Petición mala')
                    this.loadingEliminarTipoHerramienta = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 401){
                    showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                    this.loadingEliminarTipoHerramienta = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 404){
                    showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                    this.loadingEliminarTipoHerramienta = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 500){
                    showMessageError('Error 500','Error en el servidor')            
                    this.loadingEliminarTipoHerramienta = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }
            },

        // obtenemos todas los tipos de Herramientas
            async TodosTiposHerramientas(){
                this.loading = true
                const response = await this.$store.dispatch('getAllTypeTools')
                // controlamos las excepciones
                this.ControllerException(response)            
            },
        //metodos para registrar un nuevo tipo de Herramienta
            AbrirModalRegistrarTipoHerramienta(){
                if(this.permisos.crear) this.EstadoPermisoEditar = this.permisos.crear
                this.esNuevo = true
                this.TituloDialogo = "Crear"
                this.AbrirDialogoRegistrarTipoHerramienta = true
            },
            CerrarModalRegistrarTipoHerramienta(){
                this.TituloDialogo = ''
                this.AbrirDialogoRegistrarTipoHerramienta = false
            },
        //metodos para eliminar un tipo de Herramienta
            AbrirModalEliminarTipoHerramienta(item){
                this.TituloDialogo = "eliminar"
                this.tituloMensajeEliminar = item.nombre
                this.IdTipoHerramienta = item.idTipoHerramienta
                this.DialogoMensajeEliminar = true
            },
            CerrarDialogoMensajeEliminar(){
                this.DialogoMensajeEliminar = false
            },
            async EliminarTipoHerramienta(){
                this.loadingEliminarTipoHerramienta = true
                const response = await this.$store.dispatch('DeleteTypeTools', this.IdTipoHerramienta)
                this.ControllerException(response)
            },
        // metodos para editar un tipo de Herramienta
            async AbrirModalEditarTipoHerramienta(item){
                this.EstadoCircularProgress = true
                const response = await this.$store.dispatch('GetTypeToolsById', item.idTipoHerramienta)
                this.esNuevo = false
                this.TituloDialogo = "Editar"
                this.ControllerException(response)
            }
    },
}
</script>